/**
 * Работа с ценами
 * @packageDocumentation
 */

import type { Lang } from '@/core/plugins/i18n';
import { useI18nLang } from '@/core/plugins/i18n';
import Core from '@/core/core/core';

/**
 * Сгенерировать строку с суммой и валютой
 * @param sum - сумма
 * @param lang - язык, берётся из профиля, если не задано
 * @param currency - валюта, берётся из профиля, если не задано
 * @returns строка с языкозависимым представлением числа sum и знаком валюты
 */
export const genPrice = (sum: number, lang?: Lang, currency: typeof Core.state.currency = Core.state.currency): string => {
	lang = lang ?? useI18nLang().value;

	let sumStr = sum.toLocaleString(lang, { style: 'currency', currency, maximumFractionDigits: 2 });
	sumStr = sumStr.replace(',', '.');

	return sumStr;
};
